import React, { Autocomplete, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField } from '@mui/material';
import { useState } from 'react';
import { BonusCalculationService } from 'services';
import { CloseMonthDialogProps } from './CloseMonthDialogProps';

export const CloseMonthDialog = ({ open, closeDialog }: CloseMonthDialogProps) => {
	const [selectedMonth, setSelectedMonth] = useState(0);
	const months = Array.from(Array(12).keys()).map(month => ({ number: month + 1, name: new Date(0, month).toLocaleString('default', { month: 'long' }) }));
	const handleCloseMonth = async () => {
		await BonusCalculationService.processMonthlyBonusChanges(selectedMonth, 0);
		closeDialog();
	};
	return (
		<Dialog open={open} onClose={() => closeDialog()} fullWidth>
			<DialogTitle variant='h5'>Close month</DialogTitle>
			<DialogContent>
				<Grid item xs={12}>
					{months && months.length > 0 && (
						<>
							<Autocomplete
								options={months}
								getOptionLabel={option => `${option.name}`}
								value={months.find(month => month.number === selectedMonth) ?? null}
								onChange={(_, value) => setSelectedMonth(value?.number || 0)}
								renderInput={params => <TextField {...params} label='Month' size='small' />}
							/>
						</>
					)}
				</Grid>
			</DialogContent>
			<DialogActions>
				<Button variant='contained' color='error' onClick={() => closeDialog()}>
					Cancel
				</Button>
				<Button variant='contained' color='primary' onClick={handleCloseMonth}>
					Close Month
				</Button>
			</DialogActions>
		</Dialog>
	);
};